module.exports = __webpack_public_path__ + "img/envelope.9986d59d.svg";